<script setup lang="ts">
import { Toaster } from 'vue-sonner';

/**
 * Die Wurzel.
 *
 * Sie hält nichts als den Router und die Stelle, an der Meldungen erscheinen.
 * Das Layout mit der Seitenleiste ist eine Route und keine Umhüllung — sonst
 * läge der Anmeldebildschirm in einem Rahmen, in dem er nichts zu suchen hat.
 */
</script>

<template>
  <RouterView />

  <!--
    `richColors` färbt Erfolg und Fehler unterschiedlich ein. `closeButton`,
    weil eine Fehlermeldung so lange stehen bleiben soll, wie jemand sie
    lesen will — und nicht drei Sekunden.
  -->
  <Toaster position="bottom-right" rich-colors close-button :duration="6000" />
</template>
